import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import CategoryBlocksForm from "components/form/CategoryBlocksForm";
import CategoryForm from "components/form/CategoryForm";

import { SaveContextProvider } from "context/save";

import { useCategoryId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Categoria modificata con successo",
        errorMsg: "Errore nella modifica della categoria",
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaCategoria() {
    const categoryId = useCategoryId();

    return (
        <GridColumn className={"product-page"}>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica categoria</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <CategoryForm categoryId={categoryId} />

                <CategoryBlocksForm categoryId={categoryId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaCategoria;
